import { useEffect, useState } from "react";

import { useGetTemplateList } from "~/entity/Template";

export const useTemplateOptions = () => {
  const [templates, setTemplates] = useState([]);
  const { data: dataTemplates } = useGetTemplateList();

  useEffect(() => {
    if (dataTemplates) {
      const newData = dataTemplates.map((item) => {
        return { value: item.id, label: item.name };
      });
      setTemplates([...newData]);
    }
  }, [dataTemplates]);

  return templates;
};
